import script from "./FlightInfoBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./FlightInfoBoard.vue?vue&type=script&setup=true&lang=js"

import "./FlightInfoBoard.vue?vue&type=style&index=0&id=35346ea5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35346ea5"]])

export default __exports__